export default {
  None: 0,
  User: 1,
  Admin: 2,
  Internal: 3,
};
